import React from 'react'
import './Gallery.scss'
import { data } from '../../constants';

const GalleryBox = ({ info: { imgUrl, title, date } }) => (

    <div className="box">
        <img src={imgUrl} alt="" />
        <div className="content">
            <h3>{title}</h3>
            <span>{date}</span>
        </div>
    </div>
);

const Gallery = () => {
    return (
        <section className="gallery" id="gallery">

            <h1 className="heading">
                our <span>Gallery</span>
            </h1>

            <div className="box-container">
                {
                    data.gallery.map(info => (
                        <GalleryBox key={info.title} info={info} />
                    ))
                }
            </div>

        </section>
    );
}

export default Gallery